import React, { useEffect, useRef, useState } from "react";
import { useField } from "@unform/core";
import ReactInputMask from "react-input-mask";
import { Container } from "./styles";

export default function Input({
  name,
  label,
  required,
  type,
  value,
  onChange,
  ...rest
}) {
  const inputRef = useRef(null);
  const { fieldName, defaultValue = "", registerField, error } = useField(name);

  const [realValue, setRealValue] = useState(defaultValue);
  const [mask, setMask] = useState("");
  const [formatChars, setFormatChars] = useState({
    "9": "[0-9]",
    a: "[A-Z, a-z]",
    "*": "[A-Z, a-z, 0-9]",
  });

  function handleMask(event) {
    const { value } = event.target;
    if (onChange) onChange(event);
    return setRealValue(value);
  }

  useEffect(() => {
    switch (type) {
      case "telefone":
        setMask("(99) 9999-9999?");
        setFormatChars({ "9": "[0-9]", "?": "[0-9]" });
        break;
      case "celular":
        setMask("(99) 99999-9999");
        setFormatChars({ "9": "[0-9]", "?": "[0-9]" });
        break;
      case "cpf":
        setMask("999.999.999-99");
        setFormatChars({ "9": "[0-9]", "?": "[0-9]" });
        break;
      case "cpf?": // aceitamos um caractere a mais para uma gambiarra de transformação do campo em cnpj
        setMask("999.999.999-99?");
        setFormatChars({ "9": "[0-9]", "?": "[0-9]" });
        break;
      case "cnpj":
        setMask("99.999.999/9999-99");
        setFormatChars({ "9": "[0-9]", "?": "[0-9]" });
        break;
      case "cep":
        setMask("99999-999");
        setFormatChars({ "9": "[0-9]", "?": "[0-9]" });
        break;
      case "senha-numerica":
        setMask("999999");
        setFormatChars({ "9": "[0-9]", "?": "[0-9]" });
        break;
      default:
        setMask("");
        setFormatChars({
          "9": "[0-9]",
          a: "[A-Z, a-z]",
          "*": "[A-Z, a-z, 0-9]",
        });
    }
  }, [type]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "props.value",
      clearValue: inputMask => {
        inputMask.setInputValue(null);
      },
    });
    if (value) setRealValue(value);
  }, [inputRef, fieldName, value, registerField]);

  return (
    <Container>
      <label htmlFor={fieldName}>
        {label}
        {required && <span>*</span>}
      </label>
      <ReactInputMask
        type="text"
        maskChar=""
        name={name}
        value={realValue || ""}
        mask={mask}
        formatChars={formatChars}
        onChange={e => handleMask(e)}
        ref={inputRef}
        {...rest}
      />
      {error && <span className="error">{error}</span>}
    </Container>
  );
}
